import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-weather-factor-popup',
  templateUrl: './weather-factor-popup.component.html',
  styleUrls: ['./weather-factor-popup.component.scss'],
})
export class WeatherFactorPopupComponent {
  list: any;
  receivedData: any;
  formData = {
    ship_length: '',
    ship_breadth: '',
    windage_area: '',
    power: '',
    wind_drag_coef: '',
    air_density: '',
    empirical_constant: ''
  };
  constructor(
      public dialogRef: MatDialogRef<WeatherFactorPopupComponent>,
    ) {

    }
  onSubmit(confirmed: boolean) {
    const jsonString = JSON.stringify(this.formData);
    if (confirmed) {
      this.dialogRef.close(jsonString);
    }else{
      this.dialogRef.close();
    }
  }
}
